import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Delega } from 'src/app/models/rilevazione-presenze/delega';
import { StatoRilevazione } from 'src/app/models/rilevazione-presenze/rilevazione';

@Component({
    selector: 'app-delega-viewer',
    templateUrl: './delega-viewer.component.html',
    styleUrls: ['./delega-viewer.component.scss'],
    standalone: false
})
export class DelegaViewerComponent implements OnInit {
  @Input() modeDelegante: boolean;
  @Input() delega: Delega;
  @Input() enableRilCreation: boolean;
  @Output() delegaSelected = new EventEmitter();
  @Output() rilSelected = new EventEmitter();
  @Output() goToDelega = new EventEmitter();

  rilInCorso: String;

  constructor() {}

  ngOnInit() {
    console.log('ngOnInit' + this.delega , (new Date()).toLocaleTimeString());
    if(this.delega.rilevazione) {
      if(this.delega.rilevazione.stato === StatoRilevazione.IN_CORSO) {
        this.rilInCorso = StatoRilevazione.IN_CORSO.toString();
      }
      else if (this.delega.rilevazione.stato === StatoRilevazione.IN_RITARDO) {
        this.rilInCorso = StatoRilevazione.IN_RITARDO.toString();
      }
      else {
        this.rilInCorso = StatoRilevazione.CONCLUSA.toString();
      }
    }
    // console.log('ngOnInit enableRilCreation', this.enableRilCreation);
    // console.log('ngOnInit modeDelegante', this.modeDelegante);
  }

  avviaril(delega: Delega) {
    console.log('avviaril emit delega', delega);
    this.delegaSelected.emit(delega);
  }

  rimuovidelega(delega: Delega) {
    console.log('rimuovidelega emit delega', delega);
    this.delegaSelected.emit(delega);
  }

  viewril(delega: Delega) {
    console.log('viewril emit delega', delega);
    this.rilSelected.emit(delega);
  }

  modifyDelega(delega: Delega) {
    console.log('goToDelega emit delega', delega);
    this.goToDelega.emit(delega);
  }

}
